module.exports = __webpack_public_path__ + "static/media/line-icon.4205354b.svg";